import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Select2Data, Select2Module } from 'ng-select2-component';
import { SpecificDataComponent } from '../../specific-data.component';
import { StateService } from 'src/app/_service/state.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-language',
  standalone: true,
  imports: [FormsModule, Select2Module, TranslateModule],
  templateUrl: './language.component.html',
  styleUrl: './language.component.css'
})
export class LanguageComponent extends SpecificDataComponent implements OnInit{

  private eventsSubscription = new Subscription();
  languages: Select2Data;
  lang: string;

  constructor(
    private stateService: StateService,
  ) {
    super();
    this.eventsSubscription.add(
      this.stateService.getLanguage.subscribe(lang => {
        if (this.lang != lang) {
          this.specificData.idioma = lang;
          this.lang = lang;
        }
      }));
  }
  
  ngOnInit(): void {
    this.languages = [{label: "Español", value: "es"}, {label: "English", value: "en"}]
  }
  

  override isValid(): boolean {
    if (this.specificData.idioma === null) return false;
    return true;
  }

  override getValue() {
    return this.specificData;
  }
}